import DefaultTransformer from '../transformers/DefaultTransformer';
import { TransformerRegistryProps } from '../types/propTypes';

const transformerRegistry: TransformerRegistryProps = {
  default: DefaultTransformer,
};

export default transformerRegistry;
